import { render } from "./ViewAttribute.vue?vue&type=template&id=de675276"
import script from "./ViewAttribute.vue?vue&type=script&lang=js"
export * from "./ViewAttribute.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__